import {FC} from 'react'
import {KTSVG} from '_metronic/helpers'
import {currency} from 'app/format/currency'
import FulfillmentStatus from './FulfillmentStatus'
import PaymentStatus from './PaymentStatus'
import {formatToDateString2} from 'app/format/date'
import {orderType} from '../../models'
import DeliveryType from './DeliveryType'
import OrderType from './OrderType'
import MessagePopoverWithPopup from './MessagePopoverWithPopup'
import LinkState from 'app/components/Link/LinkState'
import { CustomerName } from 'app/components/customer/CustomerInfo'

type Props = {
  order: any
  onDelete: any
  filter: any
}

const OrderListItem: FC<Props> = ({order, onDelete, filter}) => {
  return (
    <tr key={order.id}>
      <td>#{order?.orderNumber}</td>
      {/* <td>{order?.invoiceNumber}</td> */}
      <td> {formatToDateString2(order.createdAt)}</td>
      <td>{order.customerName ? <CustomerName customerName={order.customerName} /> : 'Guest'}</td>
      <td>{currency(order.totalPrice)}</td>
      <td>{order.itemCount}</td>
      <td>
        <DeliveryType status={order.orderDeliveryMethod} />
      </td>
      <td>
        {order.orderType === orderType.wineClub && order.packageOrderStatus === 'NON_COMPLIANCE' ? (
          <MessagePopoverWithPopup
            message='Not Compliant'
            popupMessage={order.message}
            status={<OrderType type={order.orderType} />}
          />
        ) : (
          <OrderType type={order.orderType} />
        )}
      </td>
      <td>
        <PaymentStatus status={order.financialStatus} />
      </td>
      <td>
        <FulfillmentStatus status={order.fulfillmentStatus} />
      </td>

      <td className='d-flex justify-content-end border-0'>
        <div className='flex-shrink-0'>
          <LinkState
            id='btnOrderListEdit'
            to={`/orders/${order.id}/fulfillments/view`}
            className='btn btn-icon btn-sm btn-outline btn-outline-secondary btn-active-text-white me-2'
            state={filter}
          >
            <KTSVG path='/media/icons/corksy/edit.svg' className='svg-icon-3 svg-icon-primary' />
          </LinkState>
        </div>
      </td>
    </tr>
  )
}

export default OrderListItem
